import { useMutation } from '@tanstack/react-query'
import { queryClient } from '../../../../../App'
import { isDealer } from '../../../../../services/AccountService'
import { updateServiceOrderPut } from '../../../../../services/ApiService'

export const useReportEdit = (currentServiceData: any) => {
  const isReportEdit =
    isDealer() &&
    (14 === currentServiceData?.status ||
      ([6.2, 6.5].includes(currentServiceData?.status) &&
        currentServiceData?.dataCheckingStatus === 2))

  const { mutateAsync } = useMutation(
    {
      mutationKey: ['update-service-order-data'],
      mutationFn: (params) => updateServiceOrderPut(params),
      onSuccess() {
        queryClient.invalidateQueries({
          queryKey: ['single-service-report-table'],
        })
        queryClient.invalidateQueries({
          queryKey: ['get-service-history'],
        })
      },
    },
    queryClient
  )

  return { mutateAsync, isReportEdit }
}
